// @ts-nocheck
/* eslint-disable */
export const appChevronUp32Icon = {
    data: `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 19.6758L16 12.6758L9 19.6758" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'chevron-up-32' as const
};